import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CommonService } from 'src/app/Service/Common.service';
import { FormGroup, FormControl } from '@angular/forms';
import { IProjectElementDetailsOutput } from 'src/app/ViewModel/ProjectElementsModel';
import { ProjectInfoService } from 'src/app/Service/project-info/project-info.service';
import { Module } from 'src/app/Service/element-details.data.service';

@Component({
  selector: 'app-project-progress-dashboard',
  templateUrl: './project-progress-dashboard.component.html',
  styleUrls: ['./project-progress-dashboard.component.css']
})
export class ProjectProgressDashboardComponent implements OnInit {
  projectId!: number;
  groupId!: number;
  memberId!: number;
  public reportServer!: string;
  public reportUrl!: string;
  public showParameters!: string;
  public parameters: any;
  public language!: string;
  public height!: number;
  public width!: number;
  public toolbar!: string;
  selectedTabIndex = 0;

  public searchForm: FormGroup = new FormGroup({
    ctrlDiscipline: new FormControl(),
    ctrlStructure: new FormControl()
  });
  discList: any[] = [];
  structureList: any[] = [];
  public selectedDiscipline!: number;
  public selectedStructure!: number;

  constructor(private commonService: CommonService,
    private projService: ProjectInfoService) { }

  ngOnInit() {
    this.projectId = this.commonService.getProjectId();
    this.groupId = this.commonService.getLoggedInUserGroupId();
    this.memberId = this.commonService.getLoggedInUserId();
    // this.getElementDetails("Discipline");
    // this.getElementDetails("Structure");
    this.EmbedSSRSReport();
  }
  
  public getElementDetails(elementName: string) {
    this.projService.getProjectElementDetails({ projectId: this.projectId, groupId: this.groupId, moduleId: Module.UploadDocument, deDescription: elementName })
        .subscribe((res: IProjectElementDetailsOutput[]) => {
            switch (elementName) {
                case "Discipline":
                    this.discList = res;
                    break;
                case "Structure":
                    this.structureList = res;
                    break;
            }
        }, err => { });
}

  public EmbedSSRSReport() {
    this.language = "en-us";
    this.width = 1000;
    this.height = 620;
    this.toolbar = "true";
    this.reportServer = environment.reportHost + "EIP40Reports/EIP4EDMS/EDMS/NewDashboard";
    this.reportUrl = environment.reportHost + "EIP40Reports/EIP4EDMS/EDMS/NewDashboard";
    this.showParameters = "false";
    this.parameters = {
      "Project_Id": this.projectId
    };
  }

  public setSelectedDiscipline(event: any) {
    this.selectedDiscipline = event.value;
  }

  public setSelectedStructure(event: any) {
    this.selectedStructure = event.value;
  }

}
